var React = require('react');

function IconTrash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M11 112.7c0-21.9-.1-43.9 0-65.9 0-3 0-3.1 3-3.1h113.8c3.2 0 3.2 0 3.2 3.3v130.9c.1 8.3-2.8 15-10.2 19.4a21.5 21.5 0 0 1-11.1 2.7H32.3c-10.6-.1-18.6-6.2-20.7-15.7a27.8 27.8 0 0 1-.6-6.4c-.1-21.7 0-43.4 0-65.2zm54.4 4.5v56a16.1 16.1 0 0 0 0 2.2 5.6 5.6 0 0 0 7.4 4.6c2.6-.9 3.8-2.9 3.8-6.4V88.1c0-9.3.1-18.6 0-27.9 0-3.7-2.5-6.1-6-5.9s-5.2 2.6-5.2 6.3c-.1 18.8 0 37.7 0 56.6zm-25.3.3v-56a14.7 14.7 0 0 0 0-2.1 5.6 5.6 0 0 0-5.5-5.1c-3.6 0-5.7 2.4-5.7 6.6v112.3c0 4.5 2 7.1 5.5 7.2s5.7-2.7 5.7-7.3zm73-.3V84.6c0-8.1.1-16.3 0-24.4 0-3.7-2.6-6.1-6-5.9s-5.2 2.6-5.2 6.7q-.2 56.1-.1 112.2c0 4.5 2.2 7.2 5.7 7.2s5.6-2.7 5.6-7.2z","key":0}),React.createElement("path",{"d":"M71 36.5H3.1c-3 0-3.1-.1-3.1-3v-5.1C.1 20 5 15 13.4 15h28.9c2.2.1 3.1-.6 3.5-2.8C47.4 4.5 53 .1 61 0h19.8C89 0 94.5 4.4 96.2 12.4c.4 2 1.2 2.6 3.2 2.6 9.8-.1 19.5-.1 29.2.1a17.3 17.3 0 0 1 7.7 2c3.7 1.9 5.4 5.5 5.6 9.7.2 2.6.1 5.2.1 7.9 0 1.2-.6 1.8-1.9 1.8H71zM71 15h16c1.7 0 2-.6 1.5-2.1a6.6 6.6 0 0 0-6.7-5.1H60.2a6.4 6.4 0 0 0-6.5 4.5c-.9 2.2-.6 2.7 1.7 2.7z","key":1})]);
}

IconTrash.defaultProps = {"className":"icon trash","viewBox":"0 0 142 200"};

module.exports = IconTrash;

IconTrash.default = IconTrash;



//////////////////
// WEBPACK FOOTER
// ./src/media/icon-trash.svg
// module id = 530
// module chunks = 0